export default {
  facebook: {
    en: 'Facebook',
  },
  google: {
    en: 'Google',
  },
}
